import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Button } from 'react-bootstrap';
import { getAppointmentsById, getReferalDetail } from '../../services/Admin/adminServices';

const AppointmentDetails = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);

  const fetchDetails = async () => {
    try {
      const res = await getAppointmentsById(id);
      setDetails(res?.data?.data);
    } catch (error) {
      console.error('Error fetching details:', error);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  if (!details) return <div>Loading...</div>;

  const formatDate = (dateStr) => dateStr ? new Date(dateStr).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : 'N/A';
  const formatTime = (timeStr) => timeStr || 'N/A';

  return (
    <div className="container mt-4">
     <h2 style={{ color: "#0AB7EA" }}>Appointment Details</h2>

     <Card className="mb-3 p-3">
  <h5 className="mb-3 fw-bold">Personal Info</h5>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Full Name:</div>
    <div className="col-8">{details.fullName || 'N/A'}</div>
  </div>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Email:</div>
    <div className="col-8">{details.email || 'N/A'}</div>
  </div>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Phone:</div>
    <div className="col-8">{details.phone || 'N/A'}</div>
  </div>
</Card>

     
<Card className="mb-3 p-3">
  <h5 className="mb-3 fw-bold">Created By</h5>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Name:</div>
    <div className="col-8">{details.createdBy?.name || 'N/A'}</div>
  </div>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Email:</div>
    <div className="col-8">{details.createdBy?.email || 'N/A'}</div>
  </div>
</Card>

    <Card className="mb-3 p-3">
  <h5 className="mb-3 fw-bold">Service Info</h5>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Service Department:</div>
    <div className="col-8">{details.serviceDepartment || 'N/A'}</div>
  </div>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Purpose:</div>
    <div className="col-8">{details.purpose || 'N/A'}</div>
  </div>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Referral Source:</div>
    <div className="col-8">{details.referralSource || 'N/A'}</div>
  </div>
</Card>

      <Card className="mb-3 p-3">
        <h5>Preferred Appointment</h5>
        <p><strong>Date:</strong> {formatDate(details.preferredDate)}</p>
        <p><strong>Time:</strong> {formatTime(details.preferredTime)}</p>
        <p><strong>Alternate Date:</strong> {formatDate(details.alternateDate)}</p>
        <p><strong>Alternate Time:</strong> {formatTime(details.alternateTime)}</p>
        <p><strong>Preferred Location:</strong> {details.preferredLocation || 'N/A'}</p>
      </Card>

 


<Card className="mb-3 p-3">
  <h5 className="mb-3 fw-bold">Special Requirements</h5>
  <div className="row mb-2">
    <div className="col-12">{details.specialRequirements || 'N/A'}</div>
  </div>
</Card>


 

   <Card className="mb-3 p-3">
  <h5 className="mb-3 fw-bold">Other Contact</h5>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Name:</div>
    <div className="col-8">{details.otherContactName || 'N/A'}</div>
  </div>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Phone:</div>
    <div className="col-8">{details.otherContactPhone || 'N/A'}</div>
  </div>

  <div className="row">
    <div className="col-4 fw-semibold">Relation:</div>
    <div className="col-8">{details.otherContactRelation || 'N/A'}</div>
  </div>
</Card>


    
<Card className="mb-3 p-3">
  <h5 className="mb-3 fw-bold">Staff Notes</h5>
  <div className="row mb-2">
    <div className="col-12">{details.staffNotes || 'N/A'}</div>
  </div>
</Card>

<Card className="mb-3 p-3">
  <h5 className="mb-3 fw-bold">Submission Info</h5>

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Submitted At:</div>
    <div className="col-8">{formatDate(details.userSubmittedAt)}</div>
  </div>

  <div className="row">
    <div className="col-4 fw-semibold">Status Note:</div>
    <div className="col-8">{details.statusNote || 'N/A'}</div>
  </div>
</Card>

{details.attachmentUrl && (
  <Card className="mb-3 p-3">
    <h5 className="mb-3 fw-bold">Attachment</h5>
    <div className="row">
      <div className="col-12">
        <a href={details.attachmentUrl} target="_blank" rel="noreferrer">
          View Attachment
        </a>
      </div>
    </div>
  </Card>
)}
    </div>
  );
};

export default AppointmentDetails;
